import { useState, type FormEvent } from 'react';
import { Mail, Loader2 } from 'lucide-react';
import { requestSignInLink } from '../lib/auth';

export default function Login() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [error, setError] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setStatus('sending');
    setError('');
    try {
      await requestSignInLink(email);
      setStatus('sent');
    } catch (err) {
      setStatus('error');
      setError(err instanceof Error ? err.message : 'Något gick fel');
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center p-4 bg-surface-cream">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-3xl font-serif text-primary text-center mb-2">W:6 Stamlogen</h1>
        <p className="text-center text-ink-muted mb-6">Logga in med din e-postadress</p>

        {status === 'sent' ? (
          <div className="text-center py-8" role="status">
            <Mail className="mx-auto mb-4 text-primary" size={48} />
            <p className="text-lg font-semibold mb-2">Kolla din inkorg</p>
            <p className="text-ink-muted">
              Om <strong>{email}</strong> är inbjuden till W:6 Stamlogen-appen
              får du en inloggningslänk inom kort. Annars händer ingenting.
            </p>
            <p className="text-xs text-ink-disabled mt-4">
              Mailet kan hamna i skräpkorgen.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <label className="block">
              <span className="block text-sm font-medium mb-1">E-postadress</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => { setEmail(e.target.value); }}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
                disabled={status === 'sending'}
                autoComplete="email"
              />
            </label>
            <button
              type="submit"
              disabled={status === 'sending'}
              className="w-full bg-primary hover:bg-primary-hover disabled:opacity-50 text-white font-semibold py-3 rounded-lg flex items-center justify-center gap-2"
            >
              {status === 'sending' ? <Loader2 className="animate-spin" size={18} /> : <Mail size={18} />}
              Skicka inloggningslänk
            </button>
            {status === 'error' && (
              <p className="text-red-600 text-sm" role="alert">{error}</p>
            )}
          </form>
        )}
      </div>
    </main>
  );
}
